import React__default from 'react';
import '../../../styles/general.css.js';
import Typography from '../../DataDisplay/Typography/Typography.js';
import '../../Forms/Checkbox/Checkbox.js';
import '../../DataDisplay/Table/Table.module.scss.js';
import '../../../styles/forms.css.js';
import '../Tooltip/Tooltip.js';
import '../../Forms/ButtonIcon/ButtonIcon.module.css.js';
import 'react-intersection-observer';
import 'classnames';
import '../../../node_modules/lodash/_baseClone.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../../styles/fonts.css.js';
import '../../Forms/Button/Button.module.scss.js';
import styles from './MenuOption.module.scss.js';

const MenuOption = ({ showPointer = true, verticalPadding = 10, horizontalPadding = 10, hasBottomBorder = true, children, onAfterClick, onClick, onMouseOut, onMouseOver, }) => {
    const handleClick = () => {
        onClick && onClick();
        onAfterClick && onAfterClick();
    };
    const handleOnMouseOver = () => {
        onMouseOver && onMouseOver();
    };
    const handleOnMouseOut = () => {
        onMouseOut && onMouseOut();
    };
    return (React__default.createElement(Typography, { tag: "textsmall" },
        React__default.createElement("div", { className: `${styles.MenuOption} ${!hasBottomBorder && styles.NoBorder} ${showPointer && styles.ButtonRole}`, onKeyDown: onClick, tabIndex: showPointer ? 0 : undefined, role: showPointer ? 'button' : undefined, style: {
                paddingRight: horizontalPadding,
                paddingLeft: horizontalPadding,
                paddingTop: verticalPadding,
                paddingBottom: verticalPadding,
            }, onClick: handleClick, onMouseOver: handleOnMouseOver, onMouseOut: handleOnMouseOut }, children)));
};

export { MenuOption as default };
//# sourceMappingURL=MenuOption.js.map
